import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "99.5%",
        [theme.breakpoints.down("desktop")]: {
            padding: "0px",
        },
    },

    snackbar_container: {
        left: "45%",
        top: "100px",
        position: "fixed",
        zIndex: 100,
    },

    mainTitle_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        width: "100%",
        marginBottom: "22px",
    },

    mobile_mainTitle_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        width: "100%",
        marginBottom: "16px",
    },

    bestSolution_container: {
        marginBottom: "31px",
    },

    line: {
        width: "100%",
        borderBottom: "2px solid #979797",
        height: "1px",
        marginBottom: "28px",
    },

    subTitles_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "32px",
    },

    mobile_subTitles_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        marginBottom: "32px",
    },

    selectTitle: {
        fontSize: "16px",
    },

    mobile_selectTitle: {
        fontSize: "18px",
        marginBottom: "16px",
    },

    inputs_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        gap: "16px",
        marginBottom: "32px",
    },

    mobile_inputs_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        gap: "16px",
        marginBottom: "32px",
    },

    inputWrapper: {
        width: "494px",
        marginBottom: "8px",
    },

    mobile_inputWrapper: {
        width: "100%",
        marginBottom: "8px",
    },

    materialArray_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "36px",
    },

    leftMaterialArray: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        gap: "16px",
        marginBottom: "42px",
    },

    rightMaterialArray: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        gap: "16px",
        marginBottom: "42px",
    },

    update_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginBottom: "24px",
    },

    cardContainer: {
        width: "100%",
        marginBottom: "24px",
    },

    buttons_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        width: "100%",
        marginBottom: "20px",
    },

    buttons_container_leftSide: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    buttons_container_rightSide: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        gap: "24px",
    },

    mobile_buttons_container_rightSide: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column-reverse",
        gap: "32px",
        width: "100%",
    },

    helperText: {
        color: "#000",
    },
}));

export default useStyles;
